// SpecialSiteDetails.tsx
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import SpecialSiteTable from '../../../components/commonComponent/SpecialSiteTable';
import { IconButton, InputBase, Paper } from '@mui/material';
import { IconSearch } from '../../../icons/Icon';


const SpecialSiteDetails = () => {
  const { sites } = useSelector((state: any) => state.sectorRegionAllSites);

  // State for search query
  const [searchQuery, setSearchQuery] = useState<string | null>(null); // Search query state

  // Filtered sites based on the search query
  const filteredSites = sites.filter((site: any) => {
    const searchLower = (searchQuery ?? '').toLowerCase().trim();
    const siteName = site.sitename ? site.sitename.toLowerCase() : '';
    const siteCode = site.sitecode ? site.sitecode.toLowerCase() : '';    
    return siteName.includes(searchLower) || siteCode.includes(searchLower);
  });

  return (
    <div className="white-box mb-12">
      <div className="flex justify-content-between align-items-center title-button-wrapper mb-8">
        <div className="flex align-items-center">
          <Paper component="form" className="search-input mr-12">
            <InputBase
              placeholder="Search Site Name or Site Code"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e?.target?.value)} onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
            />
            <IconButton type="button" aria-label="search">
              <IconSearch />
            </IconButton>
          </Paper>
        </div>
      </div>
      <div className="inner-contant kitchen-dashboard">
        <SpecialSiteTable sites={filteredSites} /> {/* Pass the filtered sites to the table */}
      </div>
    </div>
  );
};

export default SpecialSiteDetails;
